(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nw-shipping-promo"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('nw-shipping-promo');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const expiry = Date.parse(dialog.dataset.expires);
    const sessionKey = 'nw-free-shipping-nov1-2026';
    if (!Number.isFinite(expiry) || Date.now() >= expiry) return;
    try {
      if (sessionStorage.getItem(sessionKey)) return;
    } catch {}
    const close = () => { if (dialog.open) dialog.close(); };
    dialog.querySelector('[data-promo-close]').addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    let attempts = 0;
    const show = () => {
      if (Date.now() >= expiry || attempts++ >= 30) return;
      if (document.hidden || document.querySelector('dialog[open], [aria-modal="true"]')) {
        window.setTimeout(show, 1000);
        return;
      }
      dialog.showModal();
      try { sessionStorage.setItem(sessionKey, 'shown'); } catch {}
      window.setTimeout(close, Math.min(expiry - Date.now(), 2147483647));
    };
    const schedule = () => window.setTimeout(show, 6000);
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nwf-apparel-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nwf-apparel-card')) {
    customElements.define('nwf-apparel-card', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.addEventListener('click', (event) => {
          const swatch = event.target.closest('[data-nwf-swatch]');
          if (!swatch || !this.contains(swatch)) return;
          const image = this.querySelector('.nwf-apparel-card__image');
          if (image && swatch.dataset.image) {
            image.srcset = swatch.dataset.srcset;
            image.src = swatch.dataset.image;
            image.alt = swatch.dataset.alt;
          }
          this.querySelectorAll('[data-nwf-swatch]').forEach((button) => button.setAttribute('aria-pressed', String(button === swatch)));
          this.querySelectorAll('[data-nwf-product-link]').forEach((link) => { link.href = swatch.dataset.url; });
          this.querySelector('[data-nwf-colour]').textContent = swatch.dataset.colour;
          this.querySelector('[data-nwf-price]').textContent = swatch.dataset.price;
          this.querySelector('[data-nwf-availability]').hidden = swatch.dataset.unavailable !== 'true';
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
